import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const REPORTS_NAV: MenuItem[] = [
  { title: 'Knowledge Assessment - Math stack', link: '/covid-learning-loss-report-math' },
  { title: 'Knowledge Assessment & Gap-Filling Actions', link: '/knowledge-assessment&gap-filling-actions' },
  { title: 'National Percentile Rank', link: '/map-summary' },
];
